<br><br>
<div class="footer-container">
    <div class="footer">
        <div class="spacing"></div>
        <div class="column">
            <h2>About Us</h2>
            <p><a href="/our-team">Our Team</a><br>
            <a href="/special-offers">Special Offers</a><br>
            <a href="/before-and-after">Before and After</a><br>
            <a href="/reviews">Reviews</a></p>
        </div>
        <div class="column">
            <h2>Contact Us</h2>
            <p><a href="/request-an-appointment">Request an Appointment</a><br>
            <a href="/contact-us">Our Contacts</a></p>
        </div>
        <div class="column">
            <br>
            <p><a href="https://goo.gl/maps/Wm9hRFMYtjdieFDH9">16300 Aurora Ave N Ste G<br>
            Shoreline, WA 98133</a><br>
            <a href="tel:+2065462322">206.546.2322</a></p>
        </div>
    </div>
    <br>
    <div><center>All Rights Reserved by &copy;Shoreline Family Dentistry 2024</center></div>
    
</div>

<style>
    *{
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        /*font-family: Arial;*/
    }
    
    .footer-container{
        background-color: #212329;
        padding: 4rem 0 2rem 0;
        color: #fff;
        /*border-radius: 15px;*/
        width:100%;
    }

    .footer{
        width: 60%;
        height: 20vh;
        background-color: 212329;
        color: #fff;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin: 0 auto;
        padding-left: 3rem;
        
    }

    .footer-heading{
        display: flex;
        flex-direction: column;
        margin-right: 4rem;
    }

    .footer-heading h2{
        margin-bottom: 2rem;
    }

    .footer-heading a{
        color: #fff;
        text-decoration: none;
        margin-bottom: 0.5rem;
    }

    .footer-heading a:hover {
        color:red;
        transition: 0.3s ease-out;
    }

    .row {
  		display: flex;
		background-color: aliceblue;
		padding: 3em 6em;
		border-radius: 15px;
	}

	.column {
		flex: 20%;
        
	}
    .spacing {
        flex: 0%;
    }
    .column a {
        color: #fff;
        text-decoration: none;
        margin-bottom: 0.5rem;
    }
    .column a:hover{
        color: rgb(134, 180, 240);
    }

    /*@media screen and (max-width: 1150px){
        .footer{
            height: 20vh;

        }
    }*/

    

</style>

<!--<footer>
    <div class="copyright">All Rights Reserved by &copy;Shoreline Family Dentisty 2022</div>
</footer>-->


<!--<footer>
    <div class="footer-left">
        
        <div class="socials">
            <a href="#"
        </div>
    </div>
    <ul class="footer-right">
        <li>
            <h2>Location</h2>

            <ul class="box">
                <li><a href="/">16300 Aurora Ave N Ste G</a></li>
                <li><a href="/">Shoreline, WA 98133</a></li>
                <li><a href="tel:+2065462322">206.546.2322</a></li>
            </ul>
        </li>
    </ul>
    <div class="footer-bottom">
        
    </div>
</footer>
</body>-->

<!--<style>
    footer{
        padding: 40px;
        text-align: center;
    }
    .copyright{
        color: #aaa;
        font-size:14px;
        display: inline-block;
        padding: 20px;
        border-top: 1px solid #ddd;
    }
</style>-->